import { handleActions } from 'redux-actions';
import { deepFreeze } from '@mw/helpers';

import {
  clearPaginatedTemplatesTableOptions,
  resetPaginatedTemplates,
  setPaginatedTemplatesPage,
  setPaginatedTemplatesSearch,
  setPaginatedTemplatesType,
  setIsLoading,
  fetchPaginatedTemplatesSuccess,
} from '~/actions/paginatedTemplates';

const initialState = deepFreeze({
  templates: [],
  total: 0,
  page: 0,
  templatesPerPage: 10,
  type: null,
  sort: 'modified',
  order: -1,
  search: '',
  isLoading: false,
});

export const paginatedTemplates = handleActions(
  {
    [setPaginatedTemplatesType]: (state, { payload: type }) => {
      const isNewType = state.type !== type;

      return isNewType
        ? {
            ...initialState,
            type,
          }
        : state;
    },
    [setPaginatedTemplatesPage]: (state, { payload: page }) => ({
      ...state,
      page,
    }),
    [setPaginatedTemplatesSearch]: (state, { payload: search }) => ({
      ...state,
      search,
      page: initialState.page,
    }),
    [clearPaginatedTemplatesTableOptions]: (state) => ({
      ...state,
      page: initialState.page,
      sort: initialState.sort,
      order: initialState.order,
      search: initialState.search,
    }),
    [resetPaginatedTemplates]: () => ({
      ...initialState,
    }),
    [setIsLoading]: (state, { payload: isLoading }) => ({
      ...state,
      isLoading,
    }),
    [fetchPaginatedTemplatesSuccess]: (
      state,
      { payload: { templates, total, page, templatesPerPage } }
    ) => ({
      ...state,
      templates,
      total,
      page,
      templatesPerPage,
      isLoading: false,
    }),
  },
  initialState
);
